<script>
    import Portfolio from "./Portfolio.svelte";
    import Componentphotosection from "./Componentphotosection.svelte";

    export let subtitle1;
    export let subtitle11;
    export let icon1;
    export let title2;
    export let subtitle2;
    export let icon2;
    export let icon3;
    export let subtitle3;
    export let subtitle33;
    export let icon4;
    export let title4;
    export let subtitle4;
    export let icon5;
    export let title5;
    export let subtitle5;
    export let icon6;
    export let title6;
    export let subtitle6;
    export let reverseOrder = false;
    export let id = '#';
    export let sectionTitle1;
    export let sectionTitle2;
</script>

<section id={id} class="section gray-bg">
    <div class="col-12 col-lg-8 offset-lg-2">
        <div class={ reverseOrder ? 'row flex-column-reverse' : 'row'}>
            <div class="col-lg-12">
                <div class="row d-flex align-content-center">
                    {#if sectionTitle1}
                        <h4 class="subTitle">{sectionTitle1}</h4>
                    {/if}
                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover" style="text-align: left">
                            <div class="icon" style="color: Mediumslateblue">
                                <i class="{icon1}"></i>
                            </div>
                            <div class="feature-content">
                                <h6 style="font-weight: bold">{@html subtitle1}</h6>
                                <p>{@html subtitle11}</p>
                            </div>
                        </div>
                    </div> <!-- col -->

                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover" style="text-align: left">
                            <div class="icon" style="color: Mediumslateblue">
                                <i class="{icon2}"></i>
                            </div>
                            <div class="feature-content">
                                <h5 class="font-alt dark-color font-weight-bold">{title2}</h5>
                                <p>{@html subtitle2}</p>
                            </div>
                        </div>
                    </div> <!-- col -->
                    {#if sectionTitle2}
                        <h4 class="subTitle">{sectionTitle2}</h4>
                    {/if}
                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover" style="text-align: left">
                            <div class="icon" style="text-align: center; color: Mediumslateblue">
                                <i class="{icon3}" ></i>
                            </div>
                            <div class="feature-content">
                                <h6 style="font-weight: bold">{@html subtitle3}</h6>
                                <p>{@html subtitle33}</p>
                            </div>
                        </div>
                    </div> <!-- col -->

                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover"style="text-align: left">
                            <div class="icon" style="color: Mediumslateblue">
                                <i class="{icon4}"></i>
                            </div>
                            <div class="feature-content">
                                <h5 class="font-alt dark-color font-weight-bold">{title4}</h5>
                                <p>{@html subtitle4}</p>
                            </div>
                        </div>
                    </div> <!-- col -->
                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover"style="text-align: left">
                            <div class="icon" style="color: Mediumslateblue">
                                <i class="{icon5}"></i>
                            </div>
                            <div class="feature-content">
                                <h5 class="font-alt dark-color font-weight-bold">{title5}</h5>
                                <p>{@html subtitle5}</p>
                            </div>
                        </div>
                    </div> <!-- col -->
                    <div class="col-lg-6 col-md-6 m-15px-tb">
                        <div class="feature-box shadow-drop-bl-hover"style="text-align: left">
                            <div class="icon" style="color: Mediumslateblue">
                                <i class="{icon6}"></i>
                            </div>
                            <div class="feature-content">
                                <h5 class="font-alt dark-color font-weight-bold">{title6}</h5>
                                <p>{@html subtitle6}</p>
                            </div>
                        </div>
                    </div> <!-- col -->
                </div> <!-- row -->
            </div>
        </div> <!-- row -->
    </div> <!-- conainer -->
</section>

<style>
    .subTitle {
        color: white;
        font-weight: bold;
        text-align: center;
        margin: 1em;
        padding: 0;
        width: 100%;
        text-transform: uppercase;
    }

    *,::after,::before{box-sizing:border-box;}
    section{display:block;}
    h2,h5,h6{margin-top:0;margin-bottom:.5rem;}
    p{margin-top:0;margin-bottom:1rem;}
    a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects;}
    a:hover{color:#0056b3;text-decoration:underline;}
    h2,h5,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit;}
    h2{font-size:2rem;}
    h5{font-size:1.25rem;}
    h6{font-size:1rem;}
    .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
    @media (min-width:576px){
        .container{max-width:540px;}
    }
    @media (min-width:768px){
        .container{max-width:720px;}
    }
    @media (min-width:992px){
        .container{max-width:960px;}
    }
    @media (min-width:1200px){
        .container{max-width:1140px;}
    }
    .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px;}
    .col-lg-6,.col-md-6{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px;}
    @media (min-width:768px){
        .col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
    }
    @media (min-width:992px){
        .col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
    }
    .btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
    @media screen and (prefers-reduced-motion:reduce){
        .btn{transition:none;}
    }
    .btn:focus,.btn:hover{text-decoration:none;}
    .btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25);}
    .btn:disabled{opacity:.65;}
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        h2,p{orphans:3;widows:3;}
        h2{page-break-after:avoid;}
        .container{min-width:992px!important;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/plugin/themify-icons/themify-icons.css */
    [class^="ti-"]{font-family:'themify';speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
    .ti-flag-alt:before{content:"\e63b";}
    .ti-check-box:before{content:"\e64d";}
    .ti-headphone:before{content:"\e69d";}
    .ti-rocket:before{content:"\e730";}
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/style.css */
    .font-alt{font-family:'Nunito', sans-serif;}
    a{text-decoration:none!important;}
    .section{padding:90px 0;}
    @media (max-width: 991px){
        .section{padding:60px 0;}
    }
    @media (max-width: 767px){
        .subTitle {
            color: black;
        }
        .section{padding:40px 0;}
    }
    .btn{font-size:12px;text-transform:uppercase;font-weight:600;letter-spacing:1px;padding:10px 22px;border-radius:5px;border:none;box-shadow:0px 8px 15px rgba(0, 0, 0, 0.1);}
    .btn-t-white{border:1px solid #fff;color:#fff;}
    .btn-t-white:hover{background:#fff;}
    .dark-color{color:#222;}
    .white-color{color:#fff;}
    .white-color-light{color:rgba(255,255,255,.8);}
    .gray-bg{background:#F7F7FD;}
    .card-box{box-shadow:0 6px 50px rgba(0,0,0,.05);padding:9%;background:#fff;min-height:100%;}
    .card-box h6{font-size:12px;font-weight:400;margin:0 0 20px;text-transform:uppercase;letter-spacing:1px;}
    .card-box h2{font-size:38px;font-weight:300;margin:0 0 20px;}
    .card-box .btn-bar{padding:40px 0 0;}
    .feature-box{padding:32px 20px;background:#fff;border:1px solid #eee;border-bottom:4px solid #eee;height: 100%;border-radius: 6px}
    .feature-box .icon{margin-bottom:15px;width:60px;height:60px;text-align:center;line-height:60px;font-size:22px;background:#F7F7FD;border-radius:50%;position: relative}
    .feature-box i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .feature-box h5{font-weight:600;margin:0 0 10px;font-size:16px;}
    .feature-box p{margin:0;}
    .m-15px-tb{margin-top:15px;margin-bottom:15px;}
    .p-50px-r{padding-right:50px;}
    @media (max-width: 991px){
        .md-p-15px-r{padding-right:15px;}
    }
    /*! CSS Used from: http://www.inventheme.com/themeforest/axoma/axoma/static/css/color/default.css */
    ::selection{background-color:#0575E6;color:#fff;}
    ::-moz-selection{background-color:#0575E6;color:#fff;}
    a:hover{color:#0575E6;}
    a,.theme-color,.btn-t-white:hover{color:#0575E6;}
    .theme-bg{background-image:linear-gradient(to right, #0020dd, #0575E6);}
    /*! CSS Used fontfaces */
 </style>